// extracted by mini-css-extract-plugin
export var chevron = "cosmoVideoBackground-module--chevron--5df9f";
export var copy = "cosmoVideoBackground-module--copy--ec7bc";
export var cosmoVideoBackground = "cosmoVideoBackground-module--cosmoVideoBackground--2c8fa";
export var video = "cosmoVideoBackground-module--video--32059";
export var videoWrapper = "cosmoVideoBackground-module--videoWrapper--61d07";